import { isPlatformBrowser } from '@angular/common'
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  PLATFORM_ID
} from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'

declare let require: any

@Component({
  selector: 'app-rich-text-input',
  templateUrl: './rich-text-input.component.html',
  styleUrls: ['./rich-text-input.component.scss']
})
export class RichTextInputComponent implements OnChanges {
  @Input() label: string
  @Input() initialValue: { value: string }
  @Input() placeholder: string
  @Input() helpText: string
  @Input() showErrors = false
  @Input() required = false
  @Input() uniqueId: string
  @Input() maxWords: number

  @Output() valueChanged: EventEmitter<{ value: string }> = new EventEmitter()

  editor: any
  editorConfig: any

  form: FormGroup
  isBrowser: boolean
  tooManyWords: boolean

  constructor(
    private formBuilder: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnChanges() {
    this.form = this.formBuilder.group({
      richText: [this.initialValue ? this.initialValue.value : '']
    })

    // A "window" reference is present on the package an it makes the SSR task fails. This workaround loads the package on browser only.
    if (isPlatformBrowser(this.platformId)) {
      this.editorConfig = {
        toolbar: ['bold', 'italic', 'Link', 'MathType'],
        placeholder: this.placeholder
      }

      // const ClassicEditor = require('@ckeditor/ckeditor5-build-classic')
      this.editor = require('./ckeditor.js')
    }
  }

  onChange(event: any) {
    const value: string = event.editor.getData()

    // Count words in the text.
    const words = value
      .replace(/(^\s*)|(\s*$)/gi, '')
      .replace(/[ ]{2,}/gi, ' ')
      .replace(/\n /, '\n')
      .split(' ')
    const wordsCount = words.length

    this.tooManyWords = this.maxWords && wordsCount > this.maxWords

    this.form.get('richText').setValue(value)
    this.valueChanged.emit({ value })
  }
}
